module.exports = __webpack_public_path__ + "static/media/hogar.ac841546.jpg";